import React from "react";
import {handleUploadedTime} from "utils";
import {ASSET_TYPE} from "components/Layout/constants";
import useAddAssetToScene from "../hooks/useAddAssetToScene";
import FavoriteOff from "images/objectPanel/ic_favorites_off.svg";
import FavoriteOn from "images/objectPanel/ic_favorites_on.svg";
import Plus from "images/objectPanel/ic_plus.svg";
import Download from "images/objectPanel/ic_download.svg";
import Delete from "images/objectPanel/ic_delete.svg";
import ToggleOn from "images/objectPanel/toggle_on.svg";
import ToggleOff from "images/objectPanel/toggle_off.svg";
import styles from "./index.module.scss";
import useHandleAssetInfo from "../hooks/useHandleAssetInfo";
import classNames from "classnames/bind";
import {useGetAssetQuery} from "hooks";

const cn = classNames.bind(styles);

function AssetItemInfoPopup({onClickEdit, id}) {
  const {data} = useGetAssetQuery(id, {staleTime: 1000 * 300, cacheTime: 1000 * 300});

  const handleShowData = text => (text ? text : "-");
  const keywords = data?.assetKeywords;

  const {addGuiToScene} = useAddAssetToScene();
  const {onClickDownload, onClickFavorite, deleteAsset} = useHandleAssetInfo();
  const isModelAsset = data?.topCategory === ASSET_TYPE.MODEL;
  const isPublic = data ? data.publicStatus : true;

  const handleClickAddToGui = () => {
    addGuiToScene(data?.name, data?.url);
  };

  const handleClickFavorite = () => {
    // asset/like 로 요청을 보낸 경우 likeStatus 가 필드에 없음(true인 것으로 가정함)
    let likeStatus;

    if (data?.likeStatus === undefined) likeStatus = true;
    else likeStatus = data?.likeStatus;

    onClickFavorite(data?.id, likeStatus);
  };

  const handleAssetDelete = () => {
    deleteAsset(data?.id);
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.title_container}>
          <div className={styles.title_wrapper}>
            <p className={styles.title}>{data?.name}</p>
          </div>
          <button onClick={handleClickFavorite}>
            <img src={data?.likeStatus === undefined || data?.likeStatus ? FavoriteOn : FavoriteOff} alt="favorite" />
          </button>
        </div>

        <div className={styles.create_info}>
          <p className={styles.creator_name}>{data?.ownerName}</p>
          <p className={styles.updated_time}>{handleUploadedTime(data?.createdAt)}</p>
        </div>
      </div>

      {keywords && (
        <div className={styles.tag_container}>
          {keywords?.map((tag, idx) => (
            <span className={styles.tag} key={idx}>
              <p className={styles.tag_text}>{tag?.name}</p>
            </span>
          ))}
        </div>
      )}

      <div className={styles.info_container}>
        <div className={styles.info}>
          <p className={styles.info_title}>Theme</p>
          <p>{handleShowData(data?.genre)}</p>
        </div>
        <div className={styles.info}>
          <p className={styles.info_title}>Public</p>
          <button className={cn("toggle_button", !data?.publicStatus && "clickable")}>
            <img src={data?.publicStatus ? ToggleOn : ToggleOff} alt="public_toggle_button" />
          </button>
        </div>

        {!isPublic && (
          <button className={styles.edit_button} onClick={() => onClickEdit(data)}>
            <p>Edit</p>
          </button>
        )}
      </div>

      <div className={styles.button_list}>
        {data?.topCategory === ASSET_TYPE.IMAGE && (
          <button className={styles.button} onClick={handleClickAddToGui}>
            <img src={Plus} alt="add_to_gui_button" />
            <p>Add to GUI</p>
          </button>
        )}

        {isModelAsset && (
          <button className={styles.button} onClick={() => onClickDownload(data?.name, data?.url, data?.mimeType)}>
            <img src={Download} alt="download_button" />
            <p>Download</p>
          </button>
        )}

        {!isPublic && (
          <button className={styles.button} onClick={handleAssetDelete}>
            <img src={Delete} alt="delete_button" />
            <p>Delete</p>
          </button>
        )}
      </div>
    </div>
  );
}

export default AssetItemInfoPopup;
